import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SipManipulationGroupApiService {

  constructor(private http: HttpClient) {}

  readonly sipManipulationGroupUrl: string = 'sipManipulation/group';

  getSipManipulationGroups(): Observable<any> {
    return this.http.get(this.sipManipulationGroupUrl);
  }

  getSipManipulationGroup(sipManipulationGroup): Observable<any> {
    return this.http.get(`${this.sipManipulationGroupUrl}/${sipManipulationGroup}`);
  }

  addSipManipulationGroup(sipManipulationGroup): Observable<any> {
    return this.http.post(this.sipManipulationGroupUrl, sipManipulationGroup);
  }

  editSipManipulationGroup(sipManipulationGroup, sipManipulationGroupId): Observable<any> {
    return this.http.put(`${this.sipManipulationGroupUrl}/${sipManipulationGroupId}`, sipManipulationGroup);
  }

  deleteSipManipulationGroup(sipManipulationGroupId): Observable<any> {
    return this.http.delete(`${this.sipManipulationGroupUrl}/${sipManipulationGroupId}`);
  }
}
